import React from "react";
import styles from "./Testimonials.module.scss";

const TestimonialCard = ({
  avatar,
  name,
  title,
  description,
  showMore
}) => {
  return (
    <div className={styles.testimonialCard}>
      <div className={styles.testimonialContent}>
        <div className={styles.testimonialHeader}>
          <div className={styles.authorInfo}>
            <img
              loading="lazy"
              src={avatar}
              alt={`${name}'s profile`}
              className={styles.authorAvatar}
            />
            <div className={styles.authorName}>{name}</div>
          </div>
          <div className={styles.testimonialTitle}>{title}</div>
          <div className={styles.testimonialText}>
            {description}
            {showMore && <span className={styles.showMoreLink}>Show more</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
